import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from 'react/api/actions';

const { taskScheduler } = actions;

class TaskSchedulerLogs extends Component {

  closeLogsSidebar = (event) => {
    const { closeTaskSchedulerLogsAction } = this.props;
    event.preventDefault();
    closeTaskSchedulerLogsAction();
  }

  renderGroupedLogs = () => {
    const { logs } = this.props;
    const groupBy = (items, key) => {
      return items.reduce((newItems, item) => {
        newItems[item.get(key)] = newItems[item.get(key)] || [];
        newItems[item.get(key)].push(item);
        return newItems;
      }, {});
    };

    const groupedLogs = groupBy(logs, 'creationDate');

    return Object.keys(groupedLogs).map(group => (
      <div key={ group } className='logGroup'>
        <strong>{ Monet.Format.DateTime.formatToLocale(group) }</strong>
        {
          groupedLogs[group].map(log => (
            <div key={ log.get('id') } className='logItem'>
              { log.get('message') }
            </div>
          ))
        }
      </div>
    ));
  };

  renderNoLogs = () => {
    return (
      <div className='noLogs'>
        { Monet.I18n.getResourcesByKey('TaskScheduler.logs.noData') }
      </div>
    );
  };

  renderLogsContent = () => {
    const { logs } = this.props;
    return logs.size ? this.renderGroupedLogs() : this.renderNoLogs();
  }

  render() {
    const { loadingLogs, activeLog, activeLogRuleType } = this.props;

    return (
      <div id='logsContainer' className={ activeLog ? 'showLogs' : '' }>
        <div id='logsTitle'>
          { Monet.I18n.getResourcesByKey('TaskScheduler.logs.title') }
        </div>
        <div id='closeLogs' onClick={ this.closeLogsSidebar }></div>
        <div id='logsSubtitle'>
          { activeLogRuleType }
        </div>
        { loadingLogs ? Monet.I18n.getResourcesByKey('TaskScheduler.loading') : this.renderLogsContent() }
      </div>
    );
  }
};

TaskSchedulerLogs.propTypes = {
  closeTaskSchedulerLogsAction: PropTypes.func.isRequired,
  logs: PropTypes.objectOf(PropTypes.any),
  loadingLogs: PropTypes.bool.isRequired,
  activeLog: PropTypes.objectOf(PropTypes.any),
  activeLogRuleType: PropTypes.string.isRequired,
};

const mapStateToProps = ({ taskScheduler }) => ({
  logs: taskScheduler.get('logs'),
  loadingLogs: taskScheduler.get('loadingLogs'),
  activeLog: taskScheduler.get('activeLog'),
  activeLogRuleType: taskScheduler.getIn(['activeLog', 'taskSchedulerRule', 'type'], ''),
});

const mapDispatchToProps = {
  closeTaskSchedulerLogsAction: taskScheduler.actionCreators.closeTaskSchedulerLogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskSchedulerLogs);
